<template>
    <div name="booking">
        
        <!-- <kakao-button 
            @onClick="onClick"
        /> -->
        <div class="info">
            <steps :step=3 />
            <!-- <div @click="onClick" class="button">
                <img class="image" src="../../assets/kakao.png" />
                <span class="text">카카오 채팅상담</span>
            </div> -->
            <div class="info-box">
                <div class="row">
                    <img class="image" src="../../../assets/medical_icon.png" />
                    <span class="title">진료 준비</span>
                </div>
                <div class="row" style="padding-left: 20px; margin-top: 16px">
                    <div class="dot" />
                    <span class="box text-bold">진료보실 질환명</span> 
                </div>
                <div class="row-flex-start nowrap" style="padding-left: 20px; margin-top: 16px" >
                    <div class="dot" />
                     <span class="text-bold"><span class="box">지금 드시고 계신 약</span> <span class="text-normal">(약 봉투, 처방전 사진 등)</span></span> 
                </div>
                <div class="row" style="padding-left: 20px; margin-top: 16px">
                    <div class="dot" />
                    <span class="text-bold"><span class="box">체온, 혈압, 혈당 수치 등 </span><span class="text-normal">(질환별 상이함)</span></span> 
                </div>
                <div class="row" style="padding-left: 20px; margin-top: 16px">
                    <div class="dot" />
                    <span class="box text-bold">약 받으실 주소</span> 
                </div>
                <div class="row" style="padding-left: 20px; margin-top: 16px;">
                    <div style="margin-left: 16px">
                        <span><span class="text-bold-underline">주민등록번호 뒷자리는 가리고 </span><span class="text-normal">보내주세요.</span></span>
                           
                    </div>
                </div>

                <div class="row" style="margin-top: 22px;">
                    <img class="image" src="../../../assets/pin.png" />
                    <span class="title">의료기관 본인확인 안내</span>
                </div>
                <div class="row" style="padding-left: 20px; margin-top: 16px">
                    <div class="dot" />
                    <span><span class="text-bold">경증장애인 (4~6등급): </span><span class="box text-bold" style="color: #184FA1; margin-left: 4px; margin-top: -2px;">해당</span></span>
                    
                </div>
                <div class="row" style="padding-left: 20px">                 
                    <span class="box text-bold-underline" style="margin-left: 16px; ">진료 시 신분증 필참</span>
                </div>
                <div class="row" style="padding-left: 20px; margin-top: 16px">
                    <div class="dot" />
                    <span class="text-bold">그 외 미해당</span>                     
                </div>
                <div class="row" style="padding-left: 36px; margin-top: 4px">                    
                    <span class="text-normal">장기요양등급보유자</span>                     
                </div>
                <div class="row" style="padding-left: 36px; margin-top: 4px;">                    
                    <span class="text-normal">중증장애인 (1~3등급)</span>                     
                </div>
            </div>
            
            <div  style="margin-top:15px;">
                
                <span class="info-bold-text">바로돌봄 고객센터 이용문의</span>
                <div class="row" style="margin-top: 16px;">
                    <img style="width: 22px;" src="../../../assets/call.png"/>
                    <span style="margin-left: 8px;" class="info-text">전화번호: 070-8655-2300</span>
                </div>
              

                <div class="row-flex-start" style="margin-top: 16px;">
                    <img style="width: 22px;" src="../../../assets/time.png"/>
                    <span style="margin-left: 8px;" class="info-text">운영시간:</span>
                    <span style="margin-left: 8px;" class="info-text">평일 09시 ~ 18시 <br>주말·공휴일 휴무</span>
                </div>
               
            </div>
            
        </div>

        
    </div>
</template>

<script>
import Steps from '@/components/molecules/sleepq/Steps';
import KakaoButton from '@/components/atoms/KakaoButton';

export default {
    name: 'booking',
    components: {
        Steps,
        KakaoButton
    },
    mounted: function()
    {
        this.topFunction();
    }, 
    methods: {
        topFunction: function() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }, 
        onClick: function()
        {
            window.open("https://pf.kakao.com/_xoDxeJG/chat", "_blank")
        }
    }
}
</script>

<style scoped>
    .info {
        width: calc(100%);
        padding-left: 16px;
        background: var(--Gray-20, #F3F5F8);
    }
    .info-box {
        border-radius: 6px;
        background: var(--Gray-00, #FFF);
        width: calc(100% - 70px);
        padding-top: 20px;
        padding-left: 20px;
        padding-right: 20px;
        padding-bottom: 20px;
    }
    .box {
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        padding: 2px 4px 0 4px;
    }
    .text-bold {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 23px; /* 127.778% */
    }
    
    .text-normal {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 19px; /* 105.556% */
        margin-left: 4px;
    }
    .text-bold-underline {
        color: #1E1E1E;
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 23px; /* 127.778% */
        text-decoration-line: underline;
    }
    .title {
        color: #184FA1;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: -0.6px;
        margin-left: 12px;
    }
    .image {
        width: 28px;
    }
    .row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .dot {
        width: 9px;
        height: 9px;
        flex-shrink: 0;
        background: var(--gray-30-stroke, #E8EAEE);
        border-radius: 50%;
        margin-right: 7px;
    }
    .question {
        width: 100%;
        background: var(--Gray-00, #FFF);
        padding-top: 30px;
        padding-left: 16px;
        padding-right: 16px;
    }
    .row-flex-start {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start
    }
    .info-bold-text {
        color: #6B7684;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 22px; /* 110% */
    }
    .info-text {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
    .nowrap {
    
        word-break: keep-all; /* 단어 단위로 줄바꿈 허용 */
    }

    .button {   
        width: calc(100% - 32px);
        height: 117px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #FFE601;
        border-radius: 6px;
        border: 1px solid var(--Gray-50, #A3AAB6);
        cursor: pointer;
        margin-bottom: 30px;
    }
    .image{
        width: 24px;
    }
    .text {
        color: #1E1E1E;
        text-align: center;
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: -0.72px;
        margin-left: 16px;
    }

    @media (min-width: 600px) {
        .info {
            width: 600px;
        }

    }

</style>


// WEBPACK FOOTER //
// src/components/organisms/sleepq/Booking.vue